<section class="gf-panel" aria-label="Descargar factura">
  <!-- Formulario -->
  <div class="download-panel-card" *ngIf="!tieneResultados && !viendoPdf">
    <div class="download-panel-icon" aria-hidden="true">
      <i class="fas fa-file-invoice"></i>
    </div>
    <div class="download-panel-copy gf-form-block">
      <h2>Descargar factura</h2>
      <p>
        Elige un filtro e ingresa los datos para consultar y descargar tu factura en PDF.
      </p>

      <form [formGroup]="formaForm" (ngSubmit)="consultar()" class="gf-form" novalidate>
        <div class="gf-field-grid">
          <div class="gf-field gf-field--full">
            <label class="gf-label" id="gf-filtro-label">Filtro *</label>
            <app-custom-select
              formControlName="filtro"
              inputId="gf-filtro"
              ariaLabelledby="gf-filtro-label"
              placeholder="Selecciona un filtro"
              [options]="filtros"
              [invalid]="camposInvalidos('filtro')">
            </app-custom-select>
            <p class="gf-err" *ngIf="camposInvalidos('filtro')">Selecciona un filtro.</p>
          </div>

          <ng-container *ngIf="filtroActual === 'DOCUMENTO'">
            <div class="gf-field">
              <label class="gf-label" id="gf-tipo-label">Tipo de identificación *</label>
              <app-custom-select
                formControlName="tipo"
                inputId="gf-tipo"
                ariaLabelledby="gf-tipo-label"
                [options]="tiposDocumentos"
                [invalid]="camposInvalidos('tipo')">
              </app-custom-select>
              <p class="gf-err" *ngIf="camposInvalidos('tipo')">Selecciona un tipo de documento.</p>
            </div>

            <div class="gf-field">
              <label class="gf-label" for="gf-numero">Número de identificación *</label>
              <input
                id="gf-numero"
                type="text"
                class="gf-input"
                formControlName="numero"
              [placeholder]="esNit ? 'Solo 9 dígitos (sin dígito de verificación)' : 'Sin puntos ni comas'"
              autocomplete="off"
              [class.is-invalid]="camposInvalidos('numero')"
              (keyup)="onNumeroKeyup($event)" />
            <p class="gf-err" *ngIf="camposInvalidos('numero')">{{ mensajeNumero }}</p>
              <p class="gf-err" *ngIf="comas">No uses comas ni punto decimal.</p>
            </div>

            <div class="gf-field gf-field--dv" *ngIf="esNit">
              <label class="gf-label" for="gf-dv">Dígito de verificación *</label>
              <input
                id="gf-dv"
                type="text"
                class="gf-input"
                formControlName="codigo"
                placeholder="0–9"
                maxlength="1"
                inputmode="numeric"
                autocomplete="off"
                [class.is-invalid]="camposInvalidos('codigo')" />
              <p class="gf-err" *ngIf="camposInvalidos('codigo')">Dígito de verificación no válido.</p>
            </div>
          </ng-container>

          <div class="gf-field gf-field--full" *ngIf="filtroActual === 'ORDEN'">
            <label class="gf-label" for="gf-orden">Número de orden de pedido *</label>
            <input
              id="gf-orden"
              type="text"
              class="gf-input"
              formControlName="ordenPedidoId"
              placeholder="7 a 10 dígitos"
              inputmode="numeric"
              maxlength="10"
              autocomplete="off"
              [class.is-invalid]="camposInvalidos('ordenPedidoId')" />
            <p class="gf-err" *ngIf="camposInvalidos('ordenPedidoId')">
              Debe tener entre 7 y 10 dígitos numéricos.
            </p>
          </div>

          <div class="gf-field" *ngIf="filtroActual === 'FACTURA'">
            <label class="gf-label" for="gf-factura">Número de factura *</label>
            <input
              id="gf-factura"
              type="text"
              class="gf-input"
              formControlName="factura"
              placeholder="Ej. FEV123456"
              maxlength="30"
              autocomplete="off"
              [class.is-invalid]="camposInvalidos('factura')"
              (keydown)="onFacturaKeydown($event)"
              (paste)="onFacturaPaste($event)" />
            <p class="gf-err" *ngIf="camposInvalidos('factura')">
              Número de factura no válido (6–30 caracteres alfanuméricos).
            </p>
          </div>

          <div class="gf-field" *ngIf="muestraAnio">
            <label class="gf-label" for="gf-anio">Año *</label>
            <input
              id="gf-anio"
              type="text"
              class="gf-input"
              formControlName="anio"
              placeholder="AAAA"
              inputmode="numeric"
              maxlength="4"
              autocomplete="off"
              [class.is-invalid]="camposInvalidos('anio')"
              (keydown)="onAnioKeydown($event)" />
            <p class="gf-err" *ngIf="camposInvalidos('anio')">
              Ingresa el año con 4 dígitos (entre {{ anioFacturaMin }} y {{ anioFacturaMax }}).
            </p>
          </div>
        </div>

        <p class="gf-hint" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>

        <div class="gf-actions">
          <button type="submit" class="btn btn-primary" [disabled]="formaForm.invalid || loading">
            <span *ngIf="!loading">Consultar</span>
            <span *ngIf="loading"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Consultando…</span>
          </button>
        </div>
        <p class="gf-footnote">* Campos obligatorios según el filtro</p>
      </form>
    </div>
  </div>

  <!-- Resultados -->
  <div class="gf-results-card" *ngIf="tieneResultados && !viendoPdf">
    <header class="gf-results-head">
      <div class="gf-results-icon" aria-hidden="true">
        <i class="fas fa-file-invoice"></i>
      </div>
      <div class="gf-results-titles">
        <p class="gf-welcome" *ngIf="nombreSaludo">
          Hola, <strong>{{ nombreSaludo }}</strong>.
        </p>
        <h2>
          Facturas encontradas
          <span class="gf-count">{{ listadoFacturas.length }}</span>
        </h2>
        <p *ngIf="tituloConsulta">{{ tituloConsulta }}</p>
      </div>
      <button type="button" class="gf-link-btn" (click)="nuevaConsulta()">
        <i class="fas fa-arrow-left" aria-hidden="true"></i>
        Nueva consulta
      </button>
    </header>

    <div class="gf-list" role="region" aria-label="Listado de facturas">
      <article class="gf-row" *ngFor="let item of listadoFacturas">
        <div class="gf-row__meta">
          <span class="gf-code" [attr.title]="'Orden ' + item.ordenPedidoId">
            <span class="gf-code__k">Ord.</span>{{ item.ordenPedidoId }}
          </span>
          <span class="gf-code gf-code--accent" [attr.title]="'Factura ' + item.numeroFactura">
            <span class="gf-code__k">Fac.</span>{{ item.numeroFactura }}
          </span>
        </div>
        <div class="gf-row__actions">
          <button type="button" class="btn btn-primary btn-sm" (click)="verFactura(item)">
            Ver factura
          </button>
          <button type="button" class="btn btn-secondary btn-sm" (click)="descargarFactura(item)">
            Descargar
          </button>
        </div>
      </article>
    </div>
  </div>

  <!-- Visor PDF -->
  <div class="gf-pdf-card" *ngIf="viendoPdf">
    <header class="gf-results-head">
      <div class="gf-results-icon" aria-hidden="true">
        <i class="fas fa-file-pdf"></i>
      </div>
      <div class="gf-results-titles">
        <p class="gf-welcome" *ngIf="nombreSaludo">
          Hola, <strong>{{ nombreSaludo }}</strong>.
        </p>
        <h2>Factura en PDF</h2>
        <p>Si no ves el documento, espera un momento o cierra e inténtalo de nuevo.</p>
      </div>
      <button type="button" class="gf-link-btn" (click)="cerrarVistaPdf()">
        <i class="fas fa-arrow-left" aria-hidden="true"></i>
        Cerrar vista
      </button>
    </header>
    <div class="gf-pdf-shell">
      <pdf-viewer
        [src]="pdfSrc!"
        [original-size]="false"
        [show-all]="true"
        [fit-to-page]="true"
        [render-text]="true"
        style="display: block; width: 100%; height: 100%;">
      </pdf-viewer>
    </div>
  </div>
</section>
